
import {localStorage} from "../localStorage/index";

export const secrets = (() => {
    var secretsStr = localStorage.getItem("secrets");
    if (!secretsStr) {
        return {};
    }
    return JSON.parse(secretsStr);
})();

export const save = callback => {
    var secretsStr = JSON.stringify(secrets);
    localStorage.setItem("secrets", secretsStr);
    return setImmediate(callback);
};

